export enum SiteLogoActionType {
  // SITE LOGO //

  // Load Logo
  LoadSiteLogo                = 'LOAD_SITE_LOGO',
  LoadSiteLogoCompleted       = 'LOAD_SITE_LOGO_COMPLETED',
  LoadSiteLogoFailed          = 'LOAD_SITE_LOGO_FAILED',

  // Update Logo
  UpdateSiteLogo              = 'UPDATE_SITE_LOGO',
  UpdateSiteLogoCompleted     = 'UPDATE_SITE_LOGO_COMPLETED',
  UpdateSiteLogoFailed        = 'UPDATE_SITE_LOGO_FAILED',

  // Delete Logo
  DeleteSiteLogo              = 'DELETE_SITE_LOGO',
  DeleteSiteLogoCompleted     = 'DELETE_SITE_LOGO_COMPLETED',
  DeleteSiteLogoFailed        = 'DELETE_SITE_LOGO_FAILED',
}
